/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import { API } from "../api";
import {
  LASR_MILE_ORDER_LIST,
  DELIVERY_RUN_SHEET,
  DELIVERY_RUN_SHEET_ORDERS,
  DELIVERY_RUN_SHEET_SEARCH_ORDERS,
  RVP_RUN_SHEET,
  RVP_RUN_SHEET_ORDERS,
  EXPORT_RUN_SHEET,
  EXPORT_DISPATCH_RUN_SHEET,
  DELIVERY_RUN_SHEET_FILTER_URL
} from "../constants/url.constant";

export const GET_DELIVERY_RUN_SHEET = "GET_DELIVERY_RUN_SHEET";
export const ADD_DELIVERY_RUN_SHEET = "ADD_DELIVERY_RUN_SHEET";
export const DELETE_DELIVERY_RUN_SHEET = "DELETE_DELIVERY_RUN_SHEET";
export const UPDATE_DELIVERY_RUN_SHEET = "UPDATE_DELIVERY_RUN_SHEET";
export const DELETE_DELIVERY_RUN_SHEET_ORDER =
  "DELETE_DELIVERY_RUN_SHEET_ORDER";

export const GET_RVP_RUN_SHEET = "GET_RVP_RUN_SHEET";
export const ADD_RVP_RUN_SHEET = "ADD_RVP_RUN_SHEET";
export const DELETE_RVP_RUN_SHEET = "DELETE_RVP_RUN_SHEET";
export const UPDATE_RVP_RUN_SHEET = "UPDATE_RVP_RUN_SHEET";

// Order run Sheet
export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS";

export const REQUEST_LAST_MILE_SHIPING_LIST = "REQUEST_LAST_MILE_SHIPING_LIST";
export const SET_LAST_MILE_SHIPING_LIST = "SET_LAST_MILE_SHIPING_LIST";

export const GET_ORDER_RECONCILIATION = "GET_ORDER_RECONCILIATION";
export const SET_SEARCH_RUN_SHEET = "SET_SEARCH_RUN_SHEET";

export const getRunSheetDetails = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        `${DELIVERY_RUN_SHEET}/${id}`
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

export const getOrderReconciliation = ({ id, status }) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        `${DELIVERY_RUN_SHEET}/reconciliation/${id}/${status}`
      );
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const setLasttMileShipingList = (data) => {
  return {
    type: SET_LAST_MILE_SHIPING_LIST,
    payload: data
  };
};

export const lasttMileShipingOrderList = ({ limit, page }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_LAST_MILE_SHIPING_LIST });
    try {
      const res = await API.get(`${LASR_MILE_ORDER_LIST}`, {
        params: {
          limit: limit,
          page: page
        }
      });

      return dispatch(setLasttMileShipingList(res));
      // return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const lastMileShipingList = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(DELIVERY_RUN_SHEET, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_DELIVERY_RUN_SHEET,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addDeliveryRunSheet = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(DELIVERY_RUN_SHEET, data);
      dispatch({
        type: ADD_DELIVERY_RUN_SHEET,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getOrderByHub = (hubCode, params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        `${DELIVERY_RUN_SHEET_SEARCH_ORDERS}/${hubCode}`,
        {
          params
        }
      );
      if (Object.keys(params).length) {
        dispatch({
          type: GET_ORDER_DETAILS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getRunSheetOrders = (deliveryRunSheetId) => {
  return async (dispatch) => {
    try {
      return await API.get(
        `${DELIVERY_RUN_SHEET_ORDERS}/${deliveryRunSheetId}`
      );
    } catch (error) {
      throw error;
    }
  };
};

export const updateDeliveryRunsheet = (id, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${DELIVERY_RUN_SHEET}/${id}`, body);
      dispatch({
        type: UPDATE_DELIVERY_RUN_SHEET,
        payload: { id, ...body }
      });
    } catch (error) {
      throw error;
    }
  };
};

export const removeDeliveryRunSheet = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${DELIVERY_RUN_SHEET}/${id}`);
      dispatch({
        type: DELETE_DELIVERY_RUN_SHEET,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeDeliveryRunSheetOrder = (id, runSheetOrderID) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(
        `${DELIVERY_RUN_SHEET}/${id}/orders/${runSheetOrderID}`
      );
      dispatch({
        type: DELETE_DELIVERY_RUN_SHEET_ORDER,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const rvpRunSheetList = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(RVP_RUN_SHEET, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_RVP_RUN_SHEET,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeRVPRunSheet = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${RVP_RUN_SHEET}/${id}`);
      dispatch({
        type: DELETE_RVP_RUN_SHEET,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addRVPRunSheet = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(RVP_RUN_SHEET, data);
      dispatch({
        type: ADD_RVP_RUN_SHEET,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getRVPRunSheetOrders = (rvpRunSheetId, params) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${RVP_RUN_SHEET_ORDERS}/${rvpRunSheetId}`, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_ORDER_DETAILS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRVPRunsheet = (id, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${RVP_RUN_SHEET}/${id}`, body);
      dispatch({
        type: UPDATE_RVP_RUN_SHEET,
        payload: { id, ...body }
      });
    } catch (error) {
      throw error;
    }
  };
};

export const exportRunSheet = (data, isDispatchExport) => {
  return async (dispatch) => {
    try {
      const url = isDispatchExport ? EXPORT_DISPATCH_RUN_SHEET : EXPORT_RUN_SHEET;
      return await API.post(url, data);
    } catch (error) {
      throw error;
    }
  };
};

export const filterRunSheet = (data) => {
  return async (dispatch) => {
    try {
      const payload = await API.post(DELIVERY_RUN_SHEET_FILTER_URL, data);
      dispatch({
        type: SET_SEARCH_RUN_SHEET,
        payload
      });
      return payload;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = {
    deliveryRunSheetRows: [],
    rvpRunSheetRows: [],
    coulmns: [],
    totalRows: 0,
    orderRows: [],
    totalOrderRow: 0
  },
  { type, payload }
) {
  switch (type) {
    case REQUEST_LAST_MILE_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_LAST_MILE_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    case SET_SEARCH_RUN_SHEET:
      return {
        ...state,
        deliveryRunSheetRows: payload
      };
    case GET_DELIVERY_RUN_SHEET:
      return {
        ...state,
        deliveryRunSheetColumns: payload.columns,
        deliveryRunSheetRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_DELIVERY_RUN_SHEET:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        deliveryRunSheetRows: [{ ...payload }, ...(state.deliveryRunSheetRows || [])]
      };
    case DELETE_DELIVERY_RUN_SHEET:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        deliveryRunSheetRows: state.deliveryRunSheetRows.filter(
          (item) => item.id !== payload
        )
      };
    case GET_ORDER_DETAILS:
      return {
        ...state,
        totalOrderRow: payload.count,
        orderRows: payload.rows,
        orderColumns: payload.columns
      };
    case UPDATE_DELIVERY_RUN_SHEET:
      return {
        ...state,
        deliveryRunSheetRows: Array.isArray(state.deliveryRunSheetRows)
          ? state.deliveryRunSheetRows.map(
              (deliveryRunSheet) =>
                deliveryRunSheet.id === payload.id
                  ? { ...deliveryRunSheet, ...payload }
                  : deliveryRunSheet
            )
          : []
      };
    case GET_RVP_RUN_SHEET:
      return {
        ...state,
        columns: payload.columns,
        rvpRunSheetRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_RVP_RUN_SHEET:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        rvpRunSheetRows: [...state.rvpRunSheetRows, { ...payload }]
      };
    case UPDATE_RVP_RUN_SHEET:
      return {
        ...state,
        rvpRunSheetRows: Array.isArray(state.rvpRunSheetRows)
          ? state.rvpRunSheetRows.map((rvpRunSheet) =>
              rvpRunSheet.id === payload.id
                ? { ...rvpRunSheet, ...payload }
                : rvpRunSheet
            )
          : []
      };
    case DELETE_RVP_RUN_SHEET:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        rvpRunSheetRows: state.rvpRunSheetRows.filter(
          (item) => item.id !== payload
        )
      };
    default:
      return state;
  }
}
